import React, { FC, useContext, useState } from 'react';
import { Menu } from 'antd';
import { NavLink, useHistory } from 'react-router-dom';
import './HeaderBox.scss';
import Union from '../../imgs/Union.svg';
import MainLogo from '../MainLogo/MainLogo';
import BurgerMenu from './Burger-Menu/BurgerMenu';
import { Context } from '../../index';
import { observer } from 'mobx-react-lite';

const HeaderBox: FC = () => {
  const { store } = useContext(Context);
  const history = useHistory();
  const headerPage = window.location.pathname === '/' ? '' : 'HeaderBox__page';
  const [panelStyle, setPanelStyle] = useState(headerPage);
  const logoutHandler = () => {
    store.logout();
    history.push('/');
  };

  return (
    <header className={`HeaderBox ${panelStyle}`}>
      <div className="HeaderBox-Logo">
        <MainLogo />
      </div>
      <div className="HeaderBox-Menu1">
        <Menu theme="light" mode="horizontal">
          <Menu.Item key="1">
            <NavLink to="/">Главная</NavLink>
          </Menu.Item>
          <Menu.Item key="2">
            <NavLink to="/map">Карта</NavLink>
          </Menu.Item>
          <Menu.Item key="3">
            <NavLink to="/about">О проекте</NavLink>
          </Menu.Item>
        </Menu>
      </div>
      <div className="HeaderBox-Menu2">
        <NavLink to="/personal-area" onClick={() => store.setCurrentTab('2')}>
          <button className="problemReport">Сообщить о проблеме</button>
        </NavLink>
        <button className="userInfo">
          {store.defaultTab && (
            <NavLink
              to="/personal-area"
              onClick={() => store.setCurrentTab(store.defaultTab)}
            >
              <div className="userInfo__icon" />
              Личный кабинет
            </NavLink>
          )}
        </button>
        {store.isAuth && (
          <>
            <div className="headerDivider" />
            <button className="login" onClick={() => logoutHandler()}>
              <img src={Union} alt="" />
            </button>
          </>
        )}
      </div>
      <BurgerMenu logOut={logoutHandler} />
    </header>
  );
};

export default observer(HeaderBox);
